(function () {
  const initSlider = (section) => {
    const sliderEl = section.querySelector(".js-our-team-slider");
    if (!sliderEl) return;

    const prevBtn = section.querySelector(".js-our-team-prev");
    const nextBtn = section.querySelector(".js-our-team-next");

    new Swiper(sliderEl, {
      loop: false,
      slidesPerView: "auto",
      spaceBetween: 0,
      speed: 600,
      mousewheel: { forceToAxis: true },
      watchSlidesProgress: true,
      navigation: {
        nextEl: nextBtn,
        prevEl: prevBtn,
        disabledClass: "swiper-button-disabled",
      },
    });
  };

  const destroySlider = (section) => {
    const sliderEl = section.querySelector(".js-our-team-slider");
    const slides = section.querySelectorAll(".js-our-team-slider-item");

    if (sliderEl?.swiper) sliderEl.swiper.destroy();
    slides.forEach((slide) => slide.removeAttribute("style"));
  };

  const initOurTeamSwiper = (section) => {
    if (!section || !section.classList.contains("our-team-section")) return;
    const sliderEl = section.querySelector(".js-our-team-slider");
    if (!sliderEl) return;

    const resizeObserver = new ResizeObserver(() => {
      if (window.innerWidth >= 990) {
        destroySlider(section);
      } else {
        if (sliderEl?.swiper) destroySlider(section);
        initSlider(section);
      }
    });

    resizeObserver.observe(section);
  };

  initOurTeamSwiper(document.currentScript.parentElement);

  document.addEventListener("shopify:section:load", function (event) {
    initOurTeamSwiper(event.target);
  });
})();
